module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"shareOfVoices":"Share of voices"},"fr":{"shareOfVoices":"Part de voix des concurrents"},"de":{"shareOfVoices":"Share of Voice der Wettbewerber"}}')
  delete Component.options._Ctor
}
